// FLOW-06 (SPEC S4; Tasks 6.0 e 6.6) — os filtros da lista de Execuções, entre a barra de filtros
// (`ExecucoesDaConta`) e o pedido ao servidor (`GET /powerflow/execucoes`). Mora fora do componente
// para a página fazer o primeiro pedido com o mesmo período que a barra mostra.
import { periodFromRange } from 'dashboard/components-next/filter-bar/period';
import { DATE_RANGE_TYPES } from 'dashboard/components/ui/DatePicker/helpers/DatePickerHelper';

// O período padrão é o de 7 dias (o resumo fica 90, R13), sem nenhum outro filtro.
export const filtrosIniciais = () => ({
  periodo: periodFromRange(DATE_RANGE_TYPES.LAST_7_DAYS),
});

// O pedido ao servidor: só o que tem valor, com o período em ISO 8601.
export function pedidoDosFiltros(valor) {
  const pedido = {
    estado: valor.estado,
    flow_nome: valor.flow_nome,
    invocador: valor.invocador,
    conversation_id: String(valor.conversation_id || '').trim(),
    execucao_id: String(valor.execucao_id || '').trim(),
    de: valor.periodo?.from
      ? new Date(valor.periodo.from * 1000).toISOString()
      : null,
    ate: valor.periodo?.to
      ? new Date(valor.periodo.to * 1000).toISOString()
      : null,
  };
  return Object.fromEntries(
    Object.entries(pedido).filter(
      ([, campo]) => campo !== null && campo !== undefined && campo !== ''
    )
  );
}
